export type WorkspaceLaneState = 'workspace_edit' | 'workspace_view'
export type LaneState = WorkspaceLaneState | 'detached_view'

export type LaneMachineState = {
  current: LaneState
  lastWorkspace: WorkspaceLaneState
}

export type LaneMachineEvent =
  | { type: 'SET_WORKSPACE_EDIT' }
  | { type: 'SET_WORKSPACE_VIEW' }
  | { type: 'ENTER_DETACHED_VIEW' }
  | { type: 'RESTORE_LAST_WORKSPACE' }

export type LaneInput = {
  isDetached: boolean
  isViewMode: boolean
}

export function resolveLaneState(input: LaneInput): LaneState {
  if (input.isDetached) return 'detached_view'
  return input.isViewMode ? 'workspace_view' : 'workspace_edit'
}

export function createLaneMachineState(initial: LaneState = 'workspace_edit'): LaneMachineState {
  if (initial === 'detached_view') {
    return {
      current: initial,
      lastWorkspace: 'workspace_edit'
    }
  }
  return {
    current: initial,
    lastWorkspace: initial
  }
}

export function reduceLaneMachineEvent(state: LaneMachineState, event: LaneMachineEvent): LaneMachineState {
  if (event.type === 'SET_WORKSPACE_EDIT') {
    return {
      current: 'workspace_edit',
      lastWorkspace: 'workspace_edit'
    }
  }

  if (event.type === 'SET_WORKSPACE_VIEW') {
    return {
      current: 'workspace_view',
      lastWorkspace: 'workspace_view'
    }
  }

  if (event.type === 'ENTER_DETACHED_VIEW') {
    return {
      current: 'detached_view',
      lastWorkspace: state.current === 'detached_view' ? state.lastWorkspace : state.current
    }
  }

  return {
    current: state.lastWorkspace,
    lastWorkspace: state.lastWorkspace
  }
}

export function isDetachedLane(state: LaneState | LaneMachineState): boolean {
  const current = typeof state === 'string' ? state : state.current
  return current === 'detached_view'
}

export function canPersistLane(state: LaneState | LaneMachineState): boolean {
  return !isDetachedLane(state)
}

export function canEditLane(state: LaneState | LaneMachineState): boolean {
  const current = typeof state === 'string' ? state : state.current
  return current === 'workspace_edit'
}

